export interface CoverItem {
  id: string;
  title: string;
  place: string;
  tag: string;
  img: string;
}

export const coverItems: CoverItem[] = [
  {
    id: "cov-1",
    title: "通勤路上那一件奶茶色长风衣",
    place: "静安寺 · 街拍",
    tag: "街拍照片",
    img: "https://readdy.ai/api/search-image?query=Editorial%20fashion%20street%20style%20portrait%20of%20a%20young%20Asian%20woman%20in%20an%20oversized%20caramel%20beige%20long%20trench%20coat%20walking%20across%20a%20warm%20minimal%20city%20sidewalk%2C%20soft%20morning%20light%2C%20neutral%20cream%20tones%2C%20magazine%20cover%20aesthetic%2C%20clean%20balanced%20composition%2C%20shallow%20depth%20of%20field%2C%20fashion%20editorial%20photography&width=800&height=1000&seq=cover-singlecoat&orientation=portrait",
  },
  {
    id: "cov-2",
    title: "赶早班机的灰色针织叠穿",
    place: "虹桥机场 · 机场照",
    tag: "机场照",
    img: "https://readdy.ai/api/search-image?query=Editorial%20airport%20style%20photo%20of%20a%20young%20man%20wearing%20layered%20grey%20knitwear%20and%20a%20soft%20wool%20coat%20carrying%20a%20minimal%20leather%20tote%20inside%20a%20bright%20warm%20modern%20airport%20terminal%2C%20natural%20window%20light%2C%20neutral%20grey%20and%20cream%20palette%2C%20candid%20editorial%20composition%2C%20fashion%20magazine%20photography&width=800&height=1000&seq=cover-greyknit&orientation=portrait",
  },
  {
    id: "cov-3",
    title: "一件廓形西装撑起的素颜工作日",
    place: "国贸 · 素颜照",
    tag: "素颜照",
    img: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20street%20style%20photo%20of%20a%20young%20woman%20with%20a%20bare%20natural%20makeup%20free%20face%20wearing%20an%20oversized%20milk%20white%20blazer%20over%20a%20plain%20tee%20on%20a%20quiet%20downtown%20street%2C%20soft%20overcast%20warm%20light%2C%20clean%20warm%20beige%20background%2C%20editorial%20magazine%20aesthetic%2C%20refined%20composition&width=800&height=1000&seq=cover-oversizeblazer&orientation=portrait",
  },
  {
    id: "cov-4",
    title: "牛仔外套反穿，周四不赶集",
    place: "太古里 · 私服照",
    tag: "私服照",
    img: "https://readdy.ai/api/search-image?query=Candid%20editorial%20street%20fashion%20photo%20of%20a%20young%20person%20in%20a%20worn%20washed%20denim%20jacket%20and%20straight%20trousers%20leaning%20against%20a%20warm%20cream%20architectural%20wall%2C%20relaxed%20casual%20pose%2C%20soft%20golden%20afternoon%20light%2C%20neutral%20earth%20tones%2C%20minimal%20editorial%20composition%2C%20fashion%20lookbook%20photography&width=800&height=1000&seq=cover-denim&orientation=portrait",
  },
];

export interface StreetItem {
  id: string;
  title: string;
  note: string;
  place: string;
  date: string;
  kind: string;
  img: string;
  ratio: "tall" | "wide";
}

export const streetItems: StreetItem[] = [
  {
    id: "st-1",
    title: "黑西装内搭白背心，周末市集首选",
    note: "把正式感穿得松弛的范本。",
    place: "杭州 · 湖滨",
    date: "今日",
    kind: "街拍照片",
    ratio: "wide",
    img: "https://readdy.ai/api/search-image?query=Editorial%20street%20style%20candid%20of%20a%20young%20man%20in%20a%20black%20blazer%20over%20a%20white%20tank%20and%20pleated%20trousers%20at%20a%20lively%20weekend%20outdoor%20market%2C%20warm%20afternoon%20sunlight%2C%20cream%20and%20black%20palette%2C%20documentary%20magazine%20aesthetic%2C%20natural%20candid%20pose%2C%20fashion%20editorial%20photography&width=1000&height=700&seq=street-blackblazer&orientation=landscape",
  },
  {
    id: "st-2",
    title: "宽松衬衫束一半，高腰牛仔裤点睛",
    note: "常见款也能有呼吸感。",
    place: "成都 · 春熙路",
    date: "昨日",
    kind: "街拍照片",
    ratio: "wide",
    img: "https://readdy.ai/api/search-image?query=Candid%20editorial%20street%20fashion%20of%20a%20young%20woman%20in%20a%20loose%20linen%20shirt%20half%20tucked%20into%20high%20waist%20light%20wash%20denim%20jeans%2C%20walking%20on%20a%20warm%20shopping%20street%2C%20soft%20dappled%20light%2C%20neutral%20cream%20and%20denim%20blue%20tones%2C%20natural%20candid%20movement%2C%20minimal%20fashion%20editorial%20photography&width=1000&height=700&seq=street-shirtdenim&orientation=landscape",
  },
  {
    id: "st-3",
    title: "风衣配乐福鞋，赶地铁也不狼狈",
    note: "通勤实穿度拉满的一组。",
    place: "上海 · 南京西路",
    date: "昨日",
    kind: "机场照",
    ratio: "tall",
    img: "https://readdy.ai/api/search-image?query=Editorial%20city%20commuter%20style%20portrait%20of%20a%20young%20woman%20in%20a%20soft%20sand%20trench%20coat%20and%20loafers%20carrying%20a%20tote%20while%20walking%20through%20a%20modern%20warm%20stone%20arcade%2C%20gentle%20morning%20light%2C%20earthy%20beige%20palette%2C%20natural%20candid%20editorial%20composition%2C%20fashion%20magazine%20photography&width=760&height=1000&seq=street-commute&orientation=portrait",
  },
  {
    id: "st-4",
    title: "一身米白在机舱门口很出片",
    note: "轻便与好看可以兼得。",
    place: "首都机场 · T2",
    date: "周一",
    kind: "机场照",
    ratio: "tall",
    img: "https://readdy.ai/api/search-image?query=Candid%20airport%20style%20photo%20of%20a%20young%20woman%20in%20an%20all%20cream%20beige%20outfit%20with%20a%20soft%20cardigan%20and%20wide%20trousers%20standing%20near%20an%20airplane%20gate%20window%2C%20bright%20warm%20natural%20light%2C%20minimal%20neutral%20palette%2C%20editorial%20documentary%20aesthetic%2C%20fashion%20magazine%20photography&width=760&height=1000&seq=street-cabin&orientation=portrait",
  },
  {
    id: "st-5",
    title: "黑色吊带裙配帆布鞋，素颜也抗打",
    note: "妆感清零，气质反而更亮。",
    place: "广州 · 天环",
    date: "周日",
    kind: "素颜照",
    ratio: "wide",
    img: "https://readdy.ai/api/search-image?query=Natural%20no%20makeup%20editorial%20fashion%20photo%20of%20a%20young%20woman%20with%20clean%20bare%20skin%20wearing%20a%20black%20slip%20dress%20and%20canvas%20sneakers%20at%20an%20open%20plaza%2C%20soft%20evening%20warm%20light%2C%20airy%20neutral%20background%2C%20effortless%20minimal%20style%2C%20fashion%20editorial%20photography%2C%20candid%20and%20realistic&width=1000&height=700&seq=street-blackdress&orientation=landscape",
  },
  {
    id: "st-6",
    title: "校服外套混搭牛仔裤，少年气溢出",
    note: "便宜单品也能穿出高级感。",
    place: "深圳 · 万象天地",
    date: "周六",
    kind: "私服照",
    ratio: "wide",
    img: "https://readdy.ai/api/search-image?query=Candid%20streetwear%20editorial%20of%20a%20young%20person%20in%20a%20retro%20varsity%20jacket%20paired%20with%20straight%20light%20denim%20jeans%20and%20white%20sneakers%20on%20a%20sunnlit%20sidewalk%2C%20playful%20casual%20pose%2C%20warm%20natural%20light%2C%20cream%20and%20muted%20tones%2C%20magazine%20street%20style%20photography&width=1000&height=700&seq=street-varsity&orientation=landscape",
  },
];

export interface CompareItem {
  id: string;
  title: string;
  source: string;
  real: string;
  gen: string;
}

export const compareItems: CompareItem[] = [
  {
    id: "cp-1",
    title: "同款西装裤生图延展三套穿法",
    source: "原图来自 · 街拍",
    real: "https://readdy.ai/api/search-image?query=Editorial%20street%20style%20portrait%20of%20a%20young%20woman%20in%20a%20straight%20charcoal%20wide%20trouser%20with%20a%20fitted%20black%20turtleneck%2C%20clean%20warm%20neutral%20studio%20street%20background%2C%20soft%20natural%20light%2C%20minimal%20fashion%20lookbook%20composition%2C%20magazine%20photography&width=800&height=1000&seq=compare-real1&orientation=portrait",
    gen: "https://readdy.ai/api/search-image?query=Stylized%20fashion%20outfit%20concept%20illustration%20of%20the%20same%20charcoal%20wide%20trouser%20restyled%20into%20three%20coordinated%20looks%20with%20a%20soft%20cream%20knit%20and%20a%20chocolate%20cargo%20jacket%2C%20warm%20beige%20backdrop%2C%20clean%20editorial%20collage%20style%2C%20fashion%20moodboard%20aesthetic%2C%20magazine%20photography&width=800&height=1000&seq=compare-gen1&orientation=portrait",
  },
  {
    id: "cp-2",
    title: "奶茶色风衣同款换不同质感",
    source: "原图来自 · 机场照",
    real: "https://readdy.ai/api/search-image?query=Candid%20editorial%20portrait%20of%20a%20young%20woman%20in%20a%20caramel%20wool%20trench%20coat%20walking%20through%20a%20bright%20airport%20lobby%2C%20soft%20natural%20light%2C%20neutral%20beige%20tones%2C%20fashion%20magazine%20photography%2C%20natural%20candid%20pose&width=800&height=1000&seq=compare-real2&orientation=portrait",
    gen: "https://readdy.ai/api/search-image?query=Design%20moodboard%20of%20the%20same%20caramel%20trench%20coat%20rendered%20in%20alternate%20fabrics%20such%20as%20linen%20leather%20and%20quilted%20cotton%2C%20warm%20sand%20studio%20background%2C%20clean%20minimal%20fashion%20editorial%20layout%2C%20coordinated%20neutral%20palette%2C%20magazine%20aesthetic&width=800&height=1000&seq=compare-gen2&orientation=portrait",
  },
  {
    id: "cp-3",
    title: "廓形西装素颜通勤的三种搭法",
    source: "原图来自 · 素颜照",
    real: "https://readdy.ai/api/search-image?query=Natural%20bare%20face%20editorial%20portrait%20of%20a%20young%20woman%20in%20an%20oversized%20milk%20white%20blazer%20and%20plain%20white%20tee%2C%20soft%20overcast%20warm%20light%2C%20quiet%20neutral%20street%2C%20clean%20minimal%20fashion%20lookbook%20photography&width=800&height=1000&seq=compare-real3&orientation=portrait",
    gen: "https://readdy.ai/api/search-image?query=Fashion%20lookbook%20concept%20showing%20the%20same%20milk%20white%20blazer%20styled%20three%20ways%20with%20a%20slip%20dress%20a%20crop%20top%20and%20pleated%20shorts%2C%20warm%20cream%20studio%20backdrop%2C%20clean%20editorial%20moodboard%20composition%2C%20neutral%20harmonious%20palette%2C%20magazine%20photography&width=800&height=1000&seq=compare-gen3&orientation=portrait",
  },
];

export interface Topic {
  name: string;
  desc: string;
  count: string;
  icon: string;
}

export const topics: Topic[] = [
  { name: "街拍照片", desc: "路人视角直出，随时更新", count: "128组", icon: "ri-camera-lens-line" },
  { name: "机场照", desc: "赶路也要体面的穿搭样本", count: "46组", icon: "ri-flight-takeoff-line" },
  { name: "私服照", desc: "非营业状态的日常搭配", count: "72组", icon: "ri-shirt-line" },
  { name: "素颜照", desc: "去滤镜之后的状态参考", count: "35组", icon: "ri-eye-off-line" },
  { name: "同款穿搭", desc: "找到单品，也找到搭法", count: "4.2k条", icon: "ri-t-shirt-line" },
  { name: "生图对比", desc: "原图同款，一键换搭思路", count: "3.6k组", icon: "ri-magic-line" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "图集里的街拍照片多久更新一次？",
    a: "吃瓜图集的街拍照片基本保持每日更新：工作日集中在午休与傍晚上下班高峰取样，周末则以商圈与市集为主。想看真实状态，可以固定关注栏目页右上角的时间戳。",
  },
  {
    q: "机场照、私服照和素颜照有什么区别？",
    a: "机场照记录赶路与候机的通勤穿搭，私服照偏向非营业的日常搭配，素颜照则强调去掉妆容与滤镜后的真实状态。三种视角的镜头语言不同，参考用途也不一样。",
  },
  {
    q: "同款穿搭生图是怎么生成的？",
    a: "你选定某一组同款穿搭的原图后，系统会依据单品的版型、颜色与气质生成多种不同搭法，便于对比配色与叠穿效果。生成结果仅作搭配灵感参考，不构成购买建议。",
  },
  {
    q: "我会不会在图上被认出来？",
    a: "图集坚持路人视角，投稿与采集均以穿搭和单品为核心，不呈现可识别的面部特写，也不关联任何个人身份信息。真实状态讲的是穿搭氛围，不是人物八卦。",
  },
  {
    q: "看到的同款去哪里找链接？",
    a: "目前图集以看图与对比为主，页面里的同款穿搭多给出品类与近似质感的文字描述，方便你去线下或购物渠道按特征寻找，不做竞价导购。",
  },
  {
    q: "内容可以转载或私藏吗？",
    a: "单张图片可自由私藏用于个人穿搭灵感收藏。若需批量转载或商业使用，请先与吃瓜图集编辑组联系并注明出处，避免侵权。",
  },
];